import { render, staticRenderFns } from "./CommercialProductDetails.vue?vue&type=template&id=3d7ab60d&scoped=true&"
import script from "./CommercialProductDetails.vue?vue&type=script&lang=js&"
export * from "./CommercialProductDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7ab60d",
  null
  
)

export default component.exports